import React, { useEffect, RefObject } from 'react';
import { setDisplayName } from 'recompose';

const EVENTS = ['mousedown', 'touchstart'];
const isNodeFound = (current, componentNode) => current === componentNode;

const createClickHandler = callback => (componentNode, props) => e => {
  const isDescendantOfRoot = componentNode && componentNode.contains(e.target);
  if (!isDescendantOfRoot) {
    return callback(props);
  }
};

const onClickOutside:any = (handler: iToggleHandler) => BaseComponent => {
  let fn;
  let instance;
  const factory = React.createFactory(BaseComponent);
  const handlerCreator = createClickHandler(handler);

  return class HandleComponent extends React.Component<any, any>{
    componentDidMount() {
      fn = handlerCreator(instance, this.props);
      if (typeof document !== 'undefined') {
        EVENTS.forEach(eventName => document.addEventListener(eventName, fn));
      }
    }

    componentWillUnmount() {
      if (typeof document !== 'undefined') {
        EVENTS.forEach(eventName => document.removeEventListener(eventName, fn));
        fn = void 0;
      }
    }

    render() {
      return (
        <div ref={r => instance = r}>
          { factory(this.props) }
        </div>
      );
    }
  };
};

type iToggleHandler = () => void;

export const useOnClickOutside = (callback: iToggleHandler, ref: RefObject<Element>) => {
  useEffect(() => {
    const onClickCallback = createClickHandler(callback)(ref.current, undefined);

    EVENTS.forEach(eventName => document.addEventListener(eventName, onClickCallback));

    return () => EVENTS.forEach(eventName => document.removeEventListener(eventName, onClickCallback));
  }, [ref])
}

export default onClickOutside;
